import React from "react";
import Feed from "../../../StudentPanel/Feed";
export default function AdminFeed(props) {
  return <Feed {...props} adminLogged currentStudent={null} />;
}
export { AdminFeed };
